module.exports = __webpack_public_path__ + "img/Ethan.52145cb7.png";